import {Component, HostListener, inject, Signal, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import {map} from 'rxjs';
import {MediaQueryService} from './services/media-query/media-query.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {LoaderService} from './services/loader/loader.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NetworkStatusService } from './services/network-status/network-status.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements  OnInit{
  title = 'rdna';
  showTheme: boolean = true;
  isProduction: boolean = false;
  showAlert: boolean = false;
  alertMessage: string = 'Staging Server';
  alertColor: string | null = 'orange';
  alertPadding:string = '1px'
  isOnline$ = this.networkStatusService.isOnline$;
  iframe: boolean = false;
  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  private loaderService: LoaderService = inject(LoaderService);
  public isLoading: Signal<boolean> = toSignal(this.loaderService.getIsLoading(), {initialValue: true});
  public isMobile: Signal< boolean > = toSignal(this.mediaQueryService.getDisplayType().pipe(map(({isMobile}) => isMobile)), {initialValue: window.innerWidth < 768});

  @HostListener('window:resize', ['$event']) onResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.mediaQueryService.setDisplaySize(width);
  }

  constructor(private router: Router, private route:ActivatedRoute, private gtmService:GoogleTagManagerService, private networkStatusService: NetworkStatusService) {
    // Subscribe to router events to check for route changes
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        // Check if the current route is "/"
        if (

          /^\/rxlogin.*/.test(event.url) ||
          event.url === '/logout' || event.url.includes('/leadership-barometer')  ||
          (event.url.includes('/shared') && window.self !== window.top) ||
          (event.url.includes('/profile') && window.self !== window.top)

        ) {
          this.showTheme = false; // Set showTheme to false if current route is "/"
        } else {
          this.showTheme = true; // Otherwise, set it to true
        }
      });
  }
  ngOnInit(): void {
    if (window.self !== window.top) {
      this.iframe = true;
    }
    this.mediaQueryService.setDisplaySize(window.innerWidth);
    // Check for token on component initialization
    this.isProduction = environment.production;
    if ((this.route.component?.name === 'PublicChartComponent' || this.route.component?.name === 'ProfileWrapperComponent') && window.self !== window.top) {
      this.showTheme = false
    }

    this.gtmService.addGtmToDom()

    this.router.events.forEach((item:any) => {
      if (item instanceof NavigationEnd) {
          const gtmTag = {
              event: 'rxi.navigation',
              pageName: item.url
          };

          this.gtmService.pushTag(gtmTag);
      }
    });
      // Log current online status
    this.isOnline$.subscribe((isOnline: any) => {
      if (isOnline) {
        console.log('User is online');
      } else {
        console.log('User is offline');
      }
      // You can perform any additional logic or UI updates based on online status here
      // For example, you could show/hide a network status alert
    });
  }
}
